import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  get: async (id) => {
    return request(`${API_URL}/contractors/customers/${id}`, 'get', {}, {});
  },

  getAvailableCustomers: async (warehouseOwnerId) => {
    return request(`${API_URL}/contractors/customers/get-available-customers/${warehouseOwnerId}`, 'post', {}, {});
  },

  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/customers/${id}`, 'put', body, {});
  },

  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/contractors/customers/`, 'post', body, {});
  },

  delete: async (id) => {
    return request(`${API_URL}/contractors/customers/${id}`, 'delete', {}, {});
  },
};
